import useFormState from "../../useFormState";

const useRCPROQuestion = ({ company }) => {
  let { actions, errors, inputsConfig, formData } = useFormState();

  const updateRcproData = (e) => {
    const { name, value, type, checked } = e.target;
    const newFields = { [name]: value };

    actions.updateRCPROSpecificInfoInputs(newFields);
  };

  return {
    updateRcproData,
    errors,
    inputsConfig,
    formData,
  };
};

export default useRCPROQuestion;
